import * as Blockly from 'blockly/core'

const DISCONNECTED_REASON = 'not_connected_to_hat'
const NO_HUMANOID_REASON = 'no_humanoid_context'
const ON_PLAY_REASON = 'on_play'
const NON_ON_PLAY_REASON = 'non_on_play'
export const DISABLED_REASONS = [
  DISCONNECTED_REASON,
  NO_HUMANOID_REASON,
  ON_PLAY_REASON,
  NON_ON_PLAY_REASON,
]

const disableBlockStack = (
  workspace: Blockly.Workspace,
  disabled: boolean,
  reason: string,
  condition: (block: Blockly.Block) => boolean,
) => {
  workspace.getTopBlocks(false).forEach((block: Blockly.Block | null) => {
    const disable = disabled && !!block && condition(block)
    while (block) {
      block.setDisabledReason(disable, reason)
      block
        .getDescendants(false)
        .forEach((b) => b.setDisabledReason(disable, reason))
      block = block.getNextBlock()
    }
  })
}

export const disableDisconnectedBlocks = (
  workspace: Blockly.Workspace,
  disabled = true,
) => {
  disableBlockStack(
    workspace,
    disabled,
    DISCONNECTED_REASON,
    (block) =>
      // If the block is not connected to the hat, disable it.
      !!block?.previousConnection ||
      // If the block is a reporter but has no output connection, disable it.
      (!!block?.outputConnection && !block.outputConnection.targetConnection),
  )
}

export const disableOnPlayBlocks = (
  workspace: Blockly.Workspace,
  disabled = true,
) => {
  disableBlockStack(
    workspace,
    disabled,
    ON_PLAY_REASON,
    (block) => block?.type === 'events_onPlay',
  )
}

export const disableNonOnPlayBlocks = (
  workspace: Blockly.Workspace,
  disabled = true,
) => {
  disableBlockStack(
    workspace,
    disabled,
    NON_ON_PLAY_REASON,
    (block) => block?.type !== 'events_onPlay',
  )
}

const HUMANOID_BLOCKS = [
  'events_setHealthTo',
  'events_setJumpPowerTo',
  'events_setWalkSpeedTo',
]
const HUMANOID_CONTEXT = ['events_onTouchCharacter']
const disableNoHumanoidBlock = (block: Blockly.Block) => {
  if (!HUMANOID_BLOCKS.includes(block.type)) {
    return
  }
  let parent = block.getParent()
  while (parent) {
    if (HUMANOID_CONTEXT.includes(parent.type)) {
      block.setDisabledReason(false, NO_HUMANOID_REASON)
      return
    }
    parent = parent.getParent()
  }
  block.setDisabledReason(true, NO_HUMANOID_REASON)
}

export const disableInvalidBlocks = (workspace: Blockly.Workspace) => {
  // Uncomment this to always disable disconnected blocks.
  // disableDisconnectedBlocks(workspace, true)
  workspace.getAllBlocks().forEach((block) => {
    disableNoHumanoidBlock(block)
  })
}
